import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreHoriz from '@material-ui/icons/MoreHoriz';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import LinearProgress from '@material-ui/core/LinearProgress';
import moment from 'moment/moment';
import DeleteDialog from '../../../components/DeleteDialog';
import { connect } from 'react-redux';
import { deleteTicket, toggleTicketFavorite } from 'Actions/ticketActions';
import { API_ROOT } from 'Api/Routes';
import CriteriaImage from 'CriteriaImage';
import OpticalDistributionImage from '../../../components/OpticalDistributionImage';
import FavButton from '../../../components/FavButton';
import {
  Bottom,
  Statistics,
  StatisticsItem,
} from 'Demand/Demand/screens/styled/Statistics';

import styled from 'styled-components';

const ExHoverMenu = styled.div`
  // position: absolute;
  // top: -4px;
  // right: 4px;
  &&& button {
    padding: 8px;
  }
  &&& svg {
    color: #404040;
  }
`;
const LinkToPhase = styled(Link)`
  color: inherit;
  text-decoration: inherit;
  width: 100%;
`;
const InfoContent = styled.div`
  display: flex;
  // display: contents;
  flex: 1;
  cursor: pointer;
  overflow: hidden;
`;
const ImageWrapper = styled.div`
  width: 118px;
  height: 118px;
`;
const SearchOptions = styled.div`
  display: flex;
  flex-direction: column;
`;

class TicketCard extends React.Component {
  state = {
    newProjectDialogOpen: false,
    anchorEl: null,
    showHover: false,
    current: moment(),
    deleteDialog: false,
  };
  interval;

  componentDidMount() {
    this.interval = setInterval(
      () => this.setState({ current: moment() }),
      60000
    );
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  openDeleteDialog = () => {
    this.setState({ deleteDialog: true, anchorEl: null });
  };
  closeDeleteDialog = () => {
    this.setState({ deleteDialog: false });
  };
  handleOpenEditDialog = () => {
    this.setState({ newProjectDialogOpen: true });
    this.handleClose();
  };
  handleCloseEditDialog = () => {
    this.setState({ newProjectDialogOpen: false });
  };
  renderQueryCriteria = () => {
    let returnString = [];
    returnString[1] = '';
    returnString[2] = '';
    if (this.props.ticket && this.props.ticket.ticketCriteria) {
      this.props.ticket.ticketCriteria.forEach((qCriteria, index) => {
        if (
          !(
            qCriteria.criteriaId === 270 ||
            qCriteria.criteriaId === 323 ||
            qCriteria.criteriaId === 325 ||
            qCriteria.criteriaId === 391 ||
            qCriteria.criteriaId === 320 ||
            qCriteria.criteriaId === 132 ||
            qCriteria.criteriaId === 389 ||
            qCriteria.criteriaId === 318 ||
            qCriteria.criteriaId === 322 ||
            qCriteria.criteriaId === 321 ||
            qCriteria.criteriaId === 319 ||
            qCriteria.criteriaId === 324 ||
            qCriteria.criteriaId === 330
          )
        ) {
          returnString[qCriteria.hierarchy] += qCriteria.name;
        }
        if (qCriteria.criteriaId === 270) {
          returnString[qCriteria.hierarchy] += 'IP';
        }
        if (qCriteria.value) {
          returnString[qCriteria.hierarchy] += ' ';
          returnString[qCriteria.hierarchy] += qCriteria.value.toString();
          if (qCriteria.unit) {
            returnString[qCriteria.hierarchy] += qCriteria.unit.toString();
          }
        }
        if (this.props.ticket.ticketCriteria[index + 1]) {
          returnString[qCriteria.hierarchy] += ', ';
        }
      });
      return (
        <div>
          {returnString[1] !== '' && (
            <p className="t-secondary-12 u-mrg-bot-5 ticket-title c-black primary-criterias">
              {returnString[1]}
            </p>
          )}
          {returnString[2] !== '' && (
            <p className="t-secondary-12 u-mrg-bot-5 ticket-title">
              {returnString[2]}
            </p>
          )}
        </div>
      );
    }
  };
  convertMS = milliseconds => {
    var day, hour, minute, seconds;
    seconds = Math.floor(milliseconds / 1000);
    minute = Math.floor(seconds / 60);
    seconds = seconds % 60;
    hour = Math.floor(minute / 60);
    minute = minute % 60;
    day = Math.floor(hour / 24);
    hour = hour % 24;
    return {
      day,
      hour,
      minute,
      seconds,
    };
  };

  goToSlip = () => {
    this.props.history.push(
      `/demand/project/${this.props.projectId}/ticket/${this.props.ticket.ticketId}/slips`
    );
  };

  renderExpiringScale = () => {
    let { ticket } = this.props;
    if (ticket && ticket.expiration) {
      let start = ticket.creatorInfo.dateCreated;
      let end = ticket.expiration;
      const stillUtcStart = moment.utc(start).toDate();
      const stillUtcEnd = moment.utc(end).toDate();
      start = moment(stillUtcStart).local();
      end = moment(stillUtcEnd).local();
      const current = this.state.current;
      const diff = end.diff(current);
      const remained = this.convertMS(diff);
      const scale =
        100 * (current.diff(start, 'days') / end.diff(start, 'days'));
      return (
        <div className="progress-wrapper">
          <LinearProgress
            className="linear-progress u-mrg-bot-5"
            classes={{
              barColorPrimary:
                scale < 80 ? 'progres_bg_primary' : 'progres_bg_secondary',
            }}
            variant="determinate"
            value={
              100 * (current.diff(start, 'days') / end.diff(start, 'days'))
            }
          />
          {remained.day >= 0 && (
            <p className="t-secondary-12 expiring-date expiring-data">
              {`${remained.day}d ${remained.hour}h ${remained.minute}m `}
            </p>
          )}
          {remained.day < 0 && (
            <span className="t-secondary-12 c-red t-weight-b expiring-data">
              Expired
            </span>
          )}
        </div>
      );
    } else {
      return false;
    }
  };

  render() {
    const { anchorEl } = this.state;
    return (
      <Grid item xs={12} md={6} lg={4} className="border-radius">
        <Paper
          // onMouseEnter={() => {
          //   this.setState({ showHover: true });
          // }}
          // onMouseLeave={() => {
          //   this.setState({ showHover: false });
          // }}
          className={`project-card has-notifications ${
            this.props.newSlipsCount || this.props.updatedSlipsCount
              ? 'project-card-updated'
              : ''
          } ${this.props.ticket.state === 'DRAFT' ? 'project-card-draft' : ''}`}
        >
          <div
            className="project-card-hover"
            style={{ display: this.state.showHover ? 'flex' : 'none' }}
          >
            <div className="project-card-hover-top">
              <FavButton
                favorited={this.props.favorite}
                toggleTicketFavorite={this.props.toggleTicketFavorite}
                projectId={this.props.projectId}
                ticketId={this.props.ticket.ticketId}
              />
              <div className="project-card-hover-menu">
                <IconButton
                  aria-label="More"
                  aria-owns={anchorEl ? 'long-menu' : null}
                  aria-haspopup="true"
                  onClick={this.handleClick}
                  className="pull-right"
                >
                  <MoreHoriz className="project-card-hover-more-icon" />
                </IconButton>
                <Menu
                  id="long-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={this.handleClose}
                >
                  <Link
                    to={{
                      pathname: `/demand/project/${this.props.projectId}/ticket/${this.props.ticket.ticketId}/edit`,
                      state: { projectId: this.props.projectId },
                    }}
                  >
                    <MenuItem key={0}>Edit</MenuItem>
                  </Link>
                  <MenuItem key={1} onClick={() => this.openDeleteDialog()}>
                    Delete
                  </MenuItem>
                </Menu>
              </div>
            </div>
            <Button
              variant="text"
              className="hollow-button"
              component={Link}
              //   to={`/demand/project/${this.props.projectId}/ticket/${
              //     this.props.ticket.ticketId
              //   }`}
              to={`/demand/project/${this.props.projectId}/ticket/${this.props.ticket.ticketId}/slips`}
            >
              View Search
            </Button>
          </div>
          {/* <NewActionHoldrer /> */}
          <div className="ticket-card-basic">
            <ImageWrapper>
              <LinkToPhase
                to={`/demand/project/${this.props.projectId}/ticket/${this.props.ticket.ticketId}/slips`}
              >
                <div className="ticket-image">
                  <OpticalDistributionImage
                    icon={this.props.ticket.opticalDistributionCriteriaId}
                  />
                  <CriteriaImage
                    iconCombination={this.props.ticket.ticketImageName}
                  />
                  {this.props.ticket &&
                  this.props.ticket.assets &&
                  this.props.ticket.assets[0] ? (
                    <div
                      style={{
                        backgroundImage: `url(${API_ROOT +
                          '/asset/' +
                          this.props.ticket.assets[0]})`,
                      }}
                    />
                  ) : (
                    <div />
                  )}
                  {this.props.ticket &&
                  this.props.ticket.assets &&
                  this.props.ticket.assets[1] ? (
                    <div
                      style={{
                        backgroundImage: `url(${API_ROOT +
                          '/asset/' +
                          this.props.ticket.assets[1]})`,
                      }}
                    />
                  ) : (
                    <div />
                  )}
                  {/* <img src="Images/lamp.jpg" alt="" /> */}
                </div>
              </LinkToPhase>
            </ImageWrapper>
            <InfoContent onClick={this.goToSlip}>
              {/* <LinkToPhase
              to={`/demand/project/${this.props.projectId}/ticket/${
                this.props.ticket.ticketId
              }/slips`}
            > */}
              <div className="content">
                <div className="t-primary-16 ticket-basic-title element-inline-block">
                  <b>{this.props.ticket.referenceName}</b>{' '}
                  <span>{this.props.ticket.name}</span>
                </div>

                {this.renderQueryCriteria()}

                {this.props.ticket.state !== 'DRAFT' &&
                  this.renderExpiringScale()}
              </div>
              {/* </LinkToPhase> */}
            </InfoContent>
            <SearchOptions>
              <ExHoverMenu className="project-card-hover-menu">
                <IconButton
                  aria-label="More"
                  aria-owns={anchorEl ? 'long-menu' : null}
                  aria-haspopup="true"
                  onClick={this.handleClick}
                  className="pull-right"
                >
                  <MoreHoriz className="project-card-hover-more-icon" />
                </IconButton>
                <Menu
                  id="long-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={this.handleClose}
                >
                  <Link
                    to={`/demand/project/${this.props.projectId}/ticket/${this.props.ticket.ticketId}/slips`}
                  >
                    <MenuItem key={2}>View</MenuItem>
                  </Link>
                  <Link
                    to={{
                      pathname: `/demand/project/${this.props.projectId}/ticket/${this.props.ticket.ticketId}/edit`,
                      state: { projectId: this.props.projectId },
                    }}
                  >
                    <MenuItem key={0}>Edit</MenuItem>
                  </Link>
                  <MenuItem key={1} onClick={() => this.openDeleteDialog()}>
                    Remove
                  </MenuItem>
                </Menu>
              </ExHoverMenu>
              <FavButton
                favorited={this.props.favorite}
                toggleTicketFavorite={this.props.toggleTicketFavorite}
                projectId={this.props.projectId}
                ticketId={this.props.ticket.ticketId}
              />
            </SearchOptions>
          </div>

          <LinkToPhase
            to={`/demand/project/${this.props.projectId}/ticket/${this.props.ticket.ticketId}/slips`}
          >
            <Bottom>
              <Statistics ticket>
                {this.props.ticket.state !== 'DRAFT' && (
                  <StatisticsItem>
                    <span
                      className={
                        !this.props.ticket.slipAnalytics
                          .hasAnyUpdatedSlipColumnOne
                          ? 'project-card-team-members-item-circle bc-secondary u-border-none t-primary-12'
                          : 'project-card-team-members-item-circle bc-red u-border-none t-primary-12'
                      }
                    >
                      {this.props.ticket.slipAnalytics
                        .numberOfNewAndViewedSlips !== null
                        ? this.props.ticket.slipAnalytics
                            .numberOfNewAndViewedSlips
                        : 0}
                    </span>
                    <span className="u-mrg-left-2 t-primary-14">
                      Luminaires
                    </span>
                  </StatisticsItem>
                )}
                {this.props.ticket.state !== 'DRAFT' && (
                  <StatisticsItem>
                    <span
                      className={
                        !this.props.ticket.slipAnalytics
                          .hasAnyUpdatedSlipColumnTwo
                          ? 'project-card-team-members-item-circle bc-secondary u-border-none t-primary-12'
                          : 'project-card-team-members-item-circle bc-yellow u-border-none t-primary-12'
                      }
                    >
                      {this.props.ticket.slipAnalytics.numberOfMatchedSlips !==
                      null
                        ? this.props.ticket.slipAnalytics.numberOfMatchedSlips
                        : 0}
                    </span>
                    <span className="u-mrg-left-2 t-primary-14">Matches</span>
                  </StatisticsItem>
                )}
                {this.props.ticket.state === 'DRAFT' && (
                  <StatisticsItem>
                    <span
                      className={
                        !this.props.ticket.slipAnalytics
                          .hasAnyUpdatedSlipColumnThree
                          ? 'project-card-team-members-item-circle bc-secondary u-border-none t-primary-12'
                          : 'project-card-team-members-item-circle bc-green u-border-none t-primary-12'
                      }
                    />
                    <span className="u-mrg-left-2 t-primary-14">
                      <b>DRAFT</b>
                    </span>
                  </StatisticsItem>
                )}
                {this.props.ticket.state !== 'DRAFT' && (
                  //   && this.props.updatedSlipsCount
                  <StatisticsItem>
                    <span className="project-card-team-members-item-circle bc-secondary t-color-w u-border-none t-primary-12">
                      {this.props.ticket.slipAnalytics.numberOfDealedSlips !==
                      null
                        ? this.props.ticket.slipAnalytics.numberOfDealedSlips
                        : 0}
                    </span>
                    <span className="u-mrg-left-2 t-primary-14">
                      Selections
                    </span>
                  </StatisticsItem>
                )}
              </Statistics>
            </Bottom>
          </LinkToPhase>
        </Paper>
        <DeleteDialog
          element={'ticket'}
          doDelete={() =>
            this.props.deleteTicket(
              this.props.projectId,
              this.props.ticket.ticketId
            )
          }
          handleClose={() => this.closeDeleteDialog()}
          isOpen={this.state.deleteDialog}
        />
      </Grid>
    );
  }
}

const mapStateToProps = store => {
  return {
    deletedTicket: store.currentProject.data,
    projects: store.projects.projects,
    currentProject: store.currentProject.project,
  };
};

const mapDispatchToProps = dispatch => ({
  deleteTicket: (projectId, ticketId) => {
    dispatch(deleteTicket(projectId, ticketId));
  },
  toggleTicketFavorite: (projectId, ticketId) => {
    dispatch(toggleTicketFavorite(projectId, ticketId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TicketCard);
